<!--  表單標題 -->
<template>
<div class="sub-header"><slot name="title"></slot><slot name="note"></slot></div>
</template>
<script>
export default {
  name: 'sub-header',
  data () {
    return {
    }
  }

}
</script>
<style lang="stylus" scoped>
.sub-header
  display: flex;
  font-size $font-size
  color $info-color
  align-items center;
  font-weight bold
  margin-bottom 10px
  letter-spacing normal
  flex 100%;
</style>
